import {
  StyledFormGroup,
  StyledSelect,
} from '@monorepo/shared/componentsV2/styled/form';
import { isRequired } from '@monorepo/shared/utils/validators';
import {
  allowedDateTransformationsForJoin,
  DatasetResponse,
  datetimeTransformationLabels,
} from 'mapistry-shared';
import React, { useMemo } from 'react';
import {
  getTimeSeriesJoinType,
  isDateConditionDisabled,
  getTimeSeriesPropertyLabel,
} from './helpers';
import {
  StyledConditionLabel,
  StyledConditionProperty,
  StyledConditionsContainer,
  StyledEqualText,
} from './styled';

interface DateIntervalConditionProps {
  className?: string;
  leftDataset: DatasetResponse;
  rightDataset: DatasetResponse;
}

export function DateIntervalCondition({
  className,
  leftDataset,
  rightDataset,
}: DateIntervalConditionProps) {
  const leftTimeSeriesPropertyLabel = useMemo(
    () => getTimeSeriesPropertyLabel(leftDataset),
    [leftDataset],
  );
  const rightTimeSeriesPropertyLabel = useMemo(
    () => getTimeSeriesPropertyLabel(rightDataset),
    [rightDataset],
  );
  const isDateIntervalDisabled = useMemo(
    () =>
      isDateConditionDisabled(getTimeSeriesJoinType(leftDataset, rightDataset)),
    [leftDataset, rightDataset],
  );
  const tooltipText = useMemo(
    () =>
      isDateIntervalDisabled
        ? `When connecting a previously aggregated data source, the interval of the aggregation is required. You can match with additional fields below.`
        : `For the data source type you chose, you must choose a date interval to match on the Log Date fields. You can match with additional fields below.`,
    [isDateIntervalDisabled],
  );
  const options = useMemo(
    () =>
      allowedDateTransformationsForJoin.map((transformation) => ({
        label: datetimeTransformationLabels[transformation],
        value: transformation,
      })),
    [],
  );

  return (
    <StyledConditionsContainer className={className}>
      <StyledFormGroup row>
        <div>
          <StyledConditionLabel>Field 1</StyledConditionLabel>
          <StyledConditionProperty
            content={leftTimeSeriesPropertyLabel}
            isLocked
          />
        </div>
        <StyledEqualText>equals</StyledEqualText>
        <div>
          <StyledConditionLabel>Field 2</StyledConditionLabel>
          <StyledConditionProperty
            content={rightTimeSeriesPropertyLabel}
            isLocked
          />
        </div>
      </StyledFormGroup>
      <StyledSelect
        label="Date Interval"
        disabled={isDateIntervalDisabled}
        options={options}
        name="dateInterval"
        required
        tooltipText={tooltipText}
        validate={isRequired}
      />
    </StyledConditionsContainer>
  );
}
